import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

const EMOJIS = ["\u{1F44D}", "\u2764\uFE0F", "\u{1F602}", "\u{1F62E}", "\u{1F622}", "\u{1F64F}", "\u{1F389}", "\u{1F525}"]

export default class extends Controller {
  static values = { url: String }

  open() {
    if (this.popover) {
      this.popover.remove()
      this.popover = null
      return
    }

    this.popover = document.createElement("div")
    this.popover.className = "absolute bottom-full mb-2 bg-white dark:bg-slate-800 rounded-lg shadow-lg border border-stone-200 dark:border-slate-600 p-2 flex gap-1 z-50"

    EMOJIS.forEach(emoji => {
      const btn = document.createElement("button")
      btn.textContent = emoji
      btn.className = "text-xl hover:bg-stone-100 dark:hover:bg-slate-700 rounded p-1 cursor-pointer"
      btn.addEventListener("click", () => this.react(emoji))
      this.popover.appendChild(btn)
    })

    this.element.style.position = "relative"
    this.element.appendChild(this.popover)

    this._outsideClick = (e) => {
      if (!this.element.contains(e.target)) {
        this.popover?.remove()
        this.popover = null
        document.removeEventListener("click", this._outsideClick)
      }
    }
    setTimeout(() => document.addEventListener("click", this._outsideClick), 0)
  }

  async react(emoji) {
    this.popover?.remove()
    this.popover = null

    const response = await fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
        "Accept": "text/vnd.turbo-stream.html"
      },
      body: JSON.stringify({ emoji: emoji })
    })

    if (response.ok) {
      const html = await response.text()
      Turbo.renderStreamMessage(html)
    }
  }

  disconnect() {
    this.popover?.remove()
    document.removeEventListener("click", this._outsideClick)
  }
}
